import React, {Component} from "react"
import PropTypes from "prop-types"
import {Select} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import withRewardOnChange from "./withRewardOnChange"

const PROPERTY = "locale"

export class Locale extends Component {
  static propTypes = {
    reward: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    referenceData: PropTypes.object.isRequired,
    required: PropTypes.bool,
    label: PropTypes.string
  }

  static defaultProps = {
    label: "Select locale:",
    required: true,
    reward: null
  }
  constructor(props) {
    super(props)

    const {reward, referenceData} = props
    const {locale} = referenceData
    const options = locale.map((l) => {
      return {
        value: l.value,
        label: l.description
      }
    })

    this.state = {
      selectedLocale: reward && reward.locale ? locale.find((l) => l.value === reward.locale) : null,
      options
    }
  }

  getSelectedLocale = () => {
    const {selectedLocale} = this.state
    return selectedLocale && selectedLocale.description
  }

  render() {
    const {onChange, required, label, reward, referenceData, ...props} = this.props
    const {options} = this.state

    if (reward.uuid) {
      return (
        <div>
          Selected locale: {this.getSelectedLocale()}
        </div>
      )
    }

    return (
      <div>
        <Select
          name={PROPERTY}
          value={reward.locale}
          options={options}
          onChange={(value) => onChange(reward, PROPERTY, value)}
          label={`${label}${required ? "*" : ""}`}
          validation={Validation.string("Please select a locale")}
          {...props}
          id={id(PROPERTY, props)} />
        <small className="text-helper">
          {"You can't change the locale after selecting"}
        </small>
      </div>
    )
  }
}

export default withRewardOnChange(Locale)
